module.exports = __webpack_public_path__ + "5261aee0f5148a0889a3d53f9cdc9d2d.png";